import './Features.css';

const features = [
  {
    icon: (
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
        <rect x="4" y="3" width="18" height="20" rx="4" stroke="#5784E6" strokeWidth="1.8"/>
        <path d="M8 9h10M8 13h7M8 17h9" stroke="#5784E6" strokeWidth="1.8" strokeLinecap="round"/>
        <circle cx="20" cy="6" r="3.5" fill="#FFB400"/>
        <path d="M19.2 6l.6.6L21.2 5" stroke="white" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: 'Not Yükleme',
    desc: 'Ders notlarını kolayca yükle ve öğrenci topluluğu ile paylaş.',
    accent: '#5784E6',
  },
  {
    icon: (
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
        <circle cx="11" cy="11" r="7" stroke="#5784E6" strokeWidth="1.8"/>
        <path d="M16.5 16.5L22 22" stroke="#5784E6" strokeWidth="2" strokeLinecap="round"/>
        <path d="M8 11h6M11 8v6" stroke="#5784E6" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
    title: 'Ders Bazlı Arama',
    desc: 'Daha iyi organizasyon için ders, bölüm ve döneme göre notları bul.',
    accent: '#5784E6',
  },
  {
    icon: (
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
        <rect x="3" y="6" width="20" height="14" rx="4" stroke="#5784E6" strokeWidth="1.8"/>
        <path d="M8 12h10M3 10h20" stroke="#5784E6" strokeWidth="1.5" strokeLinecap="round"/>
        <circle cx="20" cy="6" r="3.5" fill="#FFB400"/>
        <path d="M18.5 6h3M20 4.5v3" stroke="white" strokeWidth="1.1" strokeLinecap="round"/>
      </svg>
    ),
    title: 'Bölüm & Dönem Filtresi',
    desc: 'İhtiyacın olan notu bulmak için bölüm ve dönem bazında filtrele.',
    accent: '#5784E6',
  },
  {
    icon: (
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
        <path d="M13 3L15.5 9H22L17 13L19 19L13 15.5L7 19L9 13L4 9H10.5L13 3Z" fill="#EEF2FD" stroke="#5784E6" strokeWidth="1.6" strokeLinejoin="round"/>
        <circle cx="20" cy="6" r="3.5" fill="#FFB400"/>
        <path d="M19.2 6l.6.6L21.2 5" stroke="white" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: 'Yapay Zeka Destekli Kontrol',
    desc: 'Notlar, yapay zeka teknolojisi kullanılarak kalite ve tutarlılık açısından doğrulanır.',
    accent: '#FFB400',
  },
  {
    icon: (
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
        <path d="M13 3L16.5 6.5H20.5L19.5 10.5L23 13L19.5 15.5L20.5 19.5H16.5L13 23L9.5 19.5H5.5L6.5 15.5L3 13L6.5 10.5L5.5 6.5H9.5L13 3Z" fill="#EEF2FD" stroke="#5784E6" strokeWidth="1.5" strokeLinejoin="round"/>
        <path d="M10 13l2 2 4-4" stroke="#5784E6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: 'Güvenilir Paylaşım',
    desc: 'Moderasyon ve kalite kontrolleri ile güven odaklı bir paylaşım ortamı.',
    accent: '#4CAF50',
  },
  {
    icon: (
      <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
        <path d="M13 4C8.58 4 5 7.58 5 12C5 14.76 6.38 17.2 8.5 18.72V21.5L11 20L13 21.5L15 20L17.5 21.5V18.72C19.62 17.2 21 14.76 21 12C21 7.58 17.42 4 13 4Z" fill="#EEF2FD" stroke="#5784E6" strokeWidth="1.6" strokeLinejoin="round"/>
        <path d="M10 12l2 2 4-4" stroke="#5784E6" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: 'Öğrenci Odaklı Tasarım',
    desc: 'Özellikle üniversite öğrencileri ve ihtiyaçları için geliştirildi.',
    accent: '#5784E6',
  },
];

export default function Features() {
  return (
    <section className="features" id="features">
      <div className="container">
        <div className="features__tag">Temel Özellikler</div>
        <h2 className="section-title">Daha iyi not paylaşımı için her şey</h2>
        <p className="section-subtitle">
          NoteSwapp, öğrencilerin yüksek kaliteli ders notlarını paylaşması, keşfetmesi ve takas etmesi için ihtiyaç duydukları tüm araçları bir araya getirir.
        </p>

        <div className="features__grid">
          {features.map((feat, i) => (
            <div className="features__card" key={i}>
              <div className="features__icon-wrap">
                {feat.icon}
              </div>
              <h3 className="features__card-title">{feat.title}</h3>
              <p className="features__card-desc">{feat.desc}</p>
              <div
                className="features__card-dot"
                style={{ background: feat.accent }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
